<template>
  <v-card rounded="0">
    <v-card-item>
      <v-card color="transparent" variant="flat" @click="emit('toggle')">
        <v-row align="center">
          <v-col cols="auto">
            <RevealIcon :value="value" />
          </v-col>

          <v-col class="text-h6">{{ title }}</v-col>
        </v-row>
      </v-card>
    </v-card-item>

    <v-slide-y-transition>
      <v-card-item v-show="value">
        <slot />
      </v-card-item>

      <slot name="footer" />
    </v-slide-y-transition>
  </v-card>
</template>

<script setup>
const emit = defineEmits(['toggle'])

defineProps({
  title: {
    required: true,
    type: String
  },
  value: {
    default: false,
    type: Boolean
  }
})
</script>
